// extracted by css-extract-rspack-plugin
export default {"modal":"modal-wd2j5s","controlsContainer":"controlsContainer-KKkYyw"};